import { Component } from "react";
import { connect } from "react-redux";
import { hasWriteAccess } from "../../../state/user/selectors";

class HasWritePrivileges extends Component {
  render() {
    const { children, hasWriteAccess } = this.props;
    return hasWriteAccess ? children : null;
  }
}

const mapStateToProps = (state) => ({
  hasWriteAccess: hasWriteAccess(state),
});

export default connect(mapStateToProps)(HasWritePrivileges);
